// Mecca Prayer House is a ministry of Mecca to Christ International.
// The logo file is the parent ministry's own white-on-transparent mark, so it
// is only used on the dark footer band — it would be invisible on the yellow
// paper background the rest of the site sits on.
export const MECCA_TO_CHRIST_URL = "https://meccatochrist.org/";
export const MECCA_TO_CHRIST_NAME = "Mecca to Christ International";
export const MECCA_TO_CHRIST_LOGO = "/mecca-to-christ-logo.png";
